module.exports = __webpack_public_path__ + "img/2中国招标投标协会会员单位.e4c52ff8.png";